import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { firstValueFrom, Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return new Promise((res, rej) => {
      firstValueFrom(this.authService.isAdmin()).then(
        (is) => {
          if (is) return res(is);
          else {
            this.router.navigate(['/login']);
            return rej(is);
          }
        },
        (rej) => {
          this.router.navigate(['/login']);
          return rej(false);
        },
      );
    });
  }
}
